module.exports = __webpack_public_path__ + "static/img/logo.9c18d9ff.png";